import React, { useContext, useRef, useState } from 'react'
import Inp from './Inp'
import Datalist from '../context/Datalist'
import { Theme_context } from '../context/theme-context';
import Items_todo from './Items_todo';
import Edited_context from '../context/Edited-context';
export default function TodoParent() {
    let {theme} = useContext(Theme_context);
    let inp_todo = useRef(null);
    return (
    <div>        
        <Datalist>
            <Edited_context>
                <Inp theme = {theme} inp_todo={inp_todo}/>
                <Items_todo theme = {theme} inp_todo={inp_todo}/>
            </Edited_context>
        </Datalist>
    </div>
  )
}
